import React, { useState, useEffect } from 'react';
import { MdSearch } from 'react-icons/md';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import useMountTransition from 'hooks/useMountTransition';
import { SearchOption } from './SearchOption';
import './search.scss';

const Search = ({
  placeholderText,
  fetchTableData,
  searchTableData,
  searchKey,
  setSearchValue,
  searchOptions,
  setSearchOptionList,
}) => {
  const [showSearchBox, setSearchBoxVisible] = useState(false);
  const searchIsTransitioning = useMountTransition(showSearchBox, 500);

  useEffect(() => {
    if (!searchKey) {
      fetchTableData();
    } else {
      searchTableData();
    }
  }, [searchKey]);

    // Reset search when input is closed.
    useEffect(() => {
      if (!showSearchBox) {
        setSearchValue('');
      }
    }, [showSearchBox]);

  return (
    <>
      <button
        className={clsx('button--unstyled', 'search-trigger', {
          in: searchIsTransitioning,
          open: showSearchBox,
        })}
        onClick={() => setSearchBoxVisible(!showSearchBox)}
      >
        <MdSearch size={18} />
      </button>
      {showSearchBox && (
        <div
          className={clsx('search__inner', {
            in: searchIsTransitioning,
            open: showSearchBox,
          })}
        >
          <div
            className="view-options"
            style={{ position: 'relative' }}
          >
            <SearchOption
              value={searchKey}
              onChange={setSearchValue}
              options={searchOptions}
              setOptions={setSearchOptionList}
              placeholderText={placeholderText}
            />
          </div>
        </div>
      )}
    </>
  );
};

Search.propTypes = {
  placeholderText: PropTypes.string,
  fetchTableData: PropTypes.func,
  searchTableData: PropTypes.func,
  searchKey: PropTypes.string,
  setSearchValue: PropTypes.func,
  searchOptions: PropTypes.array,
  setSearchOptionList: PropTypes.func,
};

export default Search;
